module.exports = __webpack_public_path__ + "static/img/logo-bca.cf3f5ff1.png";